import { PolicyCheck } from '@/features/auth/authorization';

export const CallCenterPolicies: Record<string, PolicyCheck> = {
  'callcenter.agent': ({ user, acl }) => Boolean(user.is_callcenter) || acl.is_admin,
  'callcenter.manager': ({ acl }) => acl.is_admin,
};
